import React from "react";
import CountUp from "react-countup";

const Achievements = () => {
    const stats = [
        { value: 500, label: "ARTICLES PUBLICATION" },
        { value: 60, label: "BOOKS" },
        { value: 560, label: "RESEARCH PAPER" },
        { value: 1500, label: "SATISFIED CLIENT" },
    ];

    return (
        <div className="container text-center text-white py-5  px-2 bg-dark">
            <h2 className="fw-bold">ACHIEVEMENTS</h2>
            <p className="lead">
                Research Discourse: An International Peer-Reviewed Refereed Research Journal, ISSN 2277-2014(Print)
            </p>
            <hr className="custom-line bg-warning " style={{ width: "100px", height: "3px", margin: "auto" }} />

            <div className="row mt-4">
                {stats.map((stat, index) => (
                    <div key={index} className="col-md-3">
                        <div className="border p-4 rounded-3" style={{ borderColor: "rgba(255, 255, 255, 0.5)" }}>
                            <h1 className="fw-bold">
                                <CountUp start={0} end={stat.value} duration={3} delay={0.5} />
                            </h1>
                            <p className="fw-bold">{stat.label}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Achievements;
